import { getJSON } from 'bv-fetch';

export const basePath = '/api/cashout';

export const fetchBetsCount = (eventId) => getJSON(`${basePath}/open/bets/count`, {
  event_id: eventId,
});
